export const THEMES = {
  DARK: 'darkTheme',
  LIGHT: 'lightTheme',
};
